export default __webpack_public_path__ + "static/media/cif-km.f5de7525.svg";